export default {"src":"/_next/static/media/camera.9acc60a8.svg","height":24,"width":26};